import type { FormSource } from "@/lib/forms/formSource";

interface FormBuilderSourceSectionProps {
  createSource: FormSource;
  onSourceChange: (source: FormSource) => void;
}

export function FormBuilderSourceSection({
  createSource,
  onSourceChange,
}: FormBuilderSourceSectionProps) {
  return (
    <fieldset className="ml-auto shrink-0">
      <legend className="sr-only">Источник формы</legend>
      <div className="inline-flex overflow-hidden rounded-md border border-slate-200 bg-white p-0.5">
        {(
          [
            ["native", "ЦХМ"],
            ["yandex", "Яндекс"],
          ] as const
        ).map(([source, label]) => (
          <label key={source} className="cursor-pointer">
            <input
              type="radio"
              name="form-source"
              value={source}
              checked={createSource === source}
              onChange={() => onSourceChange(source)}
              className="peer sr-only"
            />
            <span className="block rounded px-2.5 py-1.5 font-onest text-xs font-medium text-slate-600 peer-checked:bg-brand-50 peer-checked:text-brand-700 peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-brand-500">
              {label}
            </span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
